export default {
    actions: {
        // после добавления товара в корзину
        addToBasketEvent({commit}, payload) {
            // gtm
            try {
                /*dataLayer.push({
                    event: 'add_to_cart',
                    value: payload.price * payload.qty,
                    eventData: {
                        currency: 'RUB',
                        items: [{
                            item_id: payload.sku,
                            item_name: payload.name,
                            price: payload.price, // 1234
                            quantity: payload.qty // 1
                        }]
                    }
                });*/

                dataLayer.push({
                    event: 'add_to_cart',
                    value: payload.price * payload.qty,
                    ecommerce: {
                        items: [{
                            item_id: payload.sku,
                            item_name: payload.name,
                            price: payload.price, // 1234
                            quantity: payload.qty // 1
                        }]
                    }
                });
            } catch(e) {}
        },
        // после изменения количества товара в корзине
        changeBasketEvent({commit}, payload) {
        },
        // после удаления товара из корзины
        deleteFromBasketEvent({commit}, payload) {
            try {
                /*dataLayer.push({
                    event: 'remove_from_cart',
                    eventData: {
                        currency: 'RUB',
                        value: payload.price * payload.qty,
                        items: [{
                            item_id: payload.sku,
                            item_name: payload.name,
                            price: payload.price,
                            quantity: payload.qty
                        }]
                    }
                });*/
                dataLayer.push({
                    event: 'remove_from_cart',
                    ecommerce: {
                        items: [{
                            item_id: payload.sku,
                            item_name: payload.name,
                            price: payload.price,
                            quantity: payload.qty
                        }]
                    }
                });
            } catch(e) {}
        },
        // после обработки сабмита формы
        formSubmittedEvent({commit}, payload) {},
        // добавление в fav
        addToWishlist({commit}, payload) {
            dataLayer.push({
                event: 'add_to_wishlist',
                eventData: {
                    currency: 'RUB',
                    value: payload.price,
                    items: [{
                        item_id: payload.article,
                        item_name: payload.name,
                        price: payload.price,
                        quantity: 1
                    }]
                }
            });
        }
    }
}